import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faFileContract,
  faBookOpen,
  faUserLock,
  faCopyright,
  faCreditCard,
  faUndo,
  faUserShield,
  faExclamationTriangle,
  faEdit,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";


const Termeni = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
           


                     <div className='tittle-ab-top'>
                        <h4>Termeni si conditii</h4>
                    </div>
           
                   
           
                {/* Informatii generale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileContract} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Informatii generale</h4>
    <p>
      Prezenta sectiune reglementeaza termenii si conditiile de utilizare a platformei ContaLearn, disponibila la adresa www.contalearn.ro. 
      Prin accesarea sau utilizarea platformei, confirmi ca ai citit, inteles si acceptat integral acesti termeni. 
      Daca nu esti de acord, te rugam sa nu folosesti platforma.
    </p>
  </div>
</section>

{/* Descrierea serviciilor */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Descrierea serviciilor</h4>
    <p>
      ContaLearn ofera acces la cursuri interactive de contabilitate, materiale educationale, teste, simulari si certificari. 
      Continutul este structurat pe module si niveluri, si poate include atat materiale gratuite, cat si resurse disponibile pe baza de abonament.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBookOpen} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Crearea si utilizarea contului */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserLock} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Crearea si utilizarea contului</h4>
    <p>
      Pentru accesarea anumitor functionalitati, este necesara crearea unui cont de utilizator. Esti responsabil pentru securitatea datelor de autentificare si pentru toate actiunile realizate prin contul tau.
    </p>
    <p>
      Ne rezervam dreptul de a suspenda sau sterge conturile care incalca termenii de utilizare sau afecteaza functionarea si securitatea platformei.
    </p>
  </div>
</section>

{/* Drepturi de autor si proprietate intelectuala */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturi de autor si proprietate intelectuala</h4>
    <p>
      Toate materialele disponibile pe platforma (texte, grafica, ilustratii, video, exercitii, cod sursa etc.) sunt proprietatea ContaLearn sau a partenerilor sai si sunt protejate de legislatia privind drepturile de autor si proprietatea intelectuala.
    </p>
    <p>
      Este strict interzisa copierea, redistribuirea, modificarea sau reutilizarea continutului in scopuri comerciale, fara acordul prealabil, expres si scris al titularului de drepturi.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCopyright} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Acces si abonamente */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCreditCard} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Acces si abonamente</h4>
    <p>
      Platforma poate include continut gratuit, precum si module premium accesibile prin abonament. Tipurile de abonamente si tarifele aferente sunt disponibile in sectiunea „Preturi” a site-ului.
    </p>
    <p>
      Plata se efectueaza prin procesatori autorizati si securizati. Pot fi oferite, ocazional, perioade de testare gratuita sau reduceri promotionale.
    </p>
  </div>
</section>

{/* Politica de rambursare */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Politica de rambursare</h4>
    <p>
      Utilizatorii pot solicita rambursarea sumei achitate in termen de 14 zile calendaristice de la activarea abonamentului, 
      cu conditia sa nu fi fost completat niciun modul integral. Pentru detalii suplimentare, consulta sectiunea „Politica de rambursare”.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUndo} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Comportament acceptabil */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserShield} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Comportament acceptabil</h4>
    <p>
      Utilizatorii se obliga sa foloseasca platforma in mod legal, etic si respectuos. 
      Este interzis orice comportament abuziv, fraudulos sau care afecteaza experienta altor utilizatori.
    </p>
    <p>
      Comentariile si feedback-ul trimis prin platforma trebuie sa fie formulate in mod civilizat si constructiv.
    </p>
  </div>
</section>

{/* Limitari ale responsabilitatii */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Limitari ale responsabilitatii</h4>
    <p>
      ContaLearn depune eforturi pentru a oferi continut actualizat, corect si relevant. Cu toate acestea, nu garantam absenta erorilor sau obtinerea unor rezultate specifice.
    </p>
    <p>
      Utilizarea informatiilor si a materialelor se face pe propria raspundere. ContaLearn nu poate fi considerata responsabila pentru pierderi, erori, decizii gresite sau efecte negative rezultate din aplicarea cunostintelor dobandite prin platforma.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faExclamationTriangle} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Modificari ale termenilor */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEdit} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Modificari ale termenilor</h4>
    <p>
      Ne rezervam dreptul de a modifica acesti termeni oricand. Versiunea actualizata va fi disponibila pe aceasta pagina si va intra in vigoare de la data publicarii.
      Continuarea utilizarii platformei reprezinta acceptul implicit al noilor conditii.
    </p>
  </div>
</section>

{/* Contact */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact</h4>
    <p>
      Pentru orice intrebare legata de acesti termeni, ne poti contacta la adresa: <strong>suport@contalearn.ro</strong>
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

           
                  
           
            <div className='line-about'></div>
           
               
           
                 </div>
               </div>
 
  );
};

export default Termeni;
